/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global snackbar, lng, URL, Promise, schema, schema, Network, CONTENT_TARGET, eyes, RestEdit, FormExportCsvBuilder */

function FormBuilder() {
  if (!this instanceof FormBuilder) return new FormBuilder();

  const that = this;

  /** An Object that controls the constrains within the formbuilder
   * @type {Constraints}
   */
  const constraints = new Constraints();
  /**
   * @type Element
   */
  this.node = document.createElement("div");

  /**
   * Will be called when user close the view.
   * Only if form is valid.
   * @param {string} json
   * Result from <i>FormBuilder.getJson()</i>
   * @returns {undefined}
   */
  this.onclose = (json) => console.warn("onclose() should be overwriten");
  this.oncancel = () => console.warn("oncancel() should be overwriten");

  /**
   * Upload all images and other files. Also delete old stuff from server.
   * Resolves with json. Each input has type:string, meta:Object: and data:Object|Array
   * @returns {Promise}
   */
  this.saveAttachmentsAndGetJson = function () {
    return new Promise((resolve, reject) => {
      //first check validity
      if (
        form.querySelector("input:invalid:not(.export)") ||
        form.querySelector("table.invalid")
      ) {
        snackbar.show({ message: lng.get("form-error-valid") });
        reject();
      }

      const promises = [];
      let allInputs = form.querySelectorAll("table.input");
      allInputs = Array.from(allInputs);
      //save some attachments
      allInputs.map((input) => {
        if (typeof input.save === "function") {
          promises.push(input.save());
        }
      });

      return (
        Promise.all(promises)
          //after save, get json from all inputs
          .then(() => resolve(getJson()))
      );
    });
  };

  this.afterSave = function (formId) {
    const promises = [];
    let allInputs = form.querySelectorAll("table.input");
    allInputs = Array.from(allInputs);

    //save some attachments
    allInputs.map((input) => {
      if (typeof input.afterSave === "function")
        promises.push(input.afterSave(formId));
    });
    tmp.classList.add("mdl-layout--fixed-drawer");
    return Promise.all(promises);
  };

  /**
   * Build some stuff by this json
   * @param {string} json
   * @returns {undefined}
   */
  this.loadJson = function (json) {
    json = JSON.parse(json);
    json.map((entry) => {
      const input = genInput(entry.type);
      input.setJson(entry);
      form.appendChild(input);
    });
    // activate constraines and call constrains
    constraints.activate();
    constraints.callAll();
  };

  //add some section wrapper
  this.node.classList.add("form-builder");
  this.node.insertAdjacentHTML(
    "beforeend",
    `
        <div class="form">
            <div class="control-bar">
                <i class="material-icons back">expand_less</i>
                <i class="material-icons save">save</i>
                <i class="material-icons cancel">cancel</i>
                <h3>${lng.get("form-title")}</h3>
                <i class="material-icons preview">photo_filter</i>
                <i class="material-icons delete">delete</i>
            </div>
        </div>
        <div class="blueprints">
            <div class="control-bar">
                <h3>${lng.get("form-blueprints-title")}</h3>
            </div>
        </div>
        <div class="preview">
            <h3>${lng.get("form-preview-title")}</h3>
            <div class="options"></div>
        </div>
    `
  );
  const backButton = this.node.querySelector(".back");
  const saveButton = this.node.querySelector(".save");
  const cancelButton = this.node.querySelector(".cancel");
  const previewButton = this.node.querySelector("i.preview");
  const deleteArea = this.node.querySelector(".delete");
  var form = this.node.querySelector(".form");
  const blueprints = this.node.querySelector(".blueprints");
  const preview = this.node.querySelector("div.preview");
  const formImageProvider = new FormImageProvider();

  form.data = {};

  // hide menu
  var tmp = document.querySelector(".mdl-layout");
  //back
  backButton.classList.add("spin");
  backButton.addEventListener("click", (e) => {
    tmp.classList.toggle("mdl-layout--fixed-drawer");
    e.target.classList.toggle("mirrored");
    e.target.classList.toggle("spin");
  });

  //save
  saveButton.addEventListener("click", function (e) {
    that
      .saveAttachmentsAndGetJson()
      .then((json) => {
        return that.onclose(json);
      })
      .then((updatedForm) => {
        return;
      })
      .then(() => that.node.parentNode.removeChild(that.node));
  });
  //cancel
  cancelButton.addEventListener("click", function (e) {
    that.node.parentNode.removeChild(that.node);
    tmp.classList.add("mdl-layout--fixed-drawer");
    that.oncancel();
  });
  //preview
  previewButton.addEventListener("click", function (e) {
    if (!preview.classList.toggle("active")) {
      //hide
      return;
    }

    showPreview();
  });
  const previewPartnerInput = RestEdit.genInput(
    {
      type: "model",
      via: "partner",
      getString: (row) => row.partner.name,
    },
    "partner",
    preview.querySelector(".options")
  );
  previewPartnerInput.placeholder = lng.get("form-preview-partnerInput");
  previewPartnerInput.onAutoCompleete = function (partner) {
    const logoUrl = schema.partnerLogo.endPoint + "/" + partner.partnerLogo;
    formImageProvider.add("partner_logo", logoUrl);
    showPreview();
  };

  //append some blueprings
  const allTypes = [
    "image",
    "default",
    "address",
    "tel",
    "text",
    "textArea",
    "multichoice",
    "raffle",
    "sign",
    "hr",
  ];
  allTypes.map((type) => {
    const input = genInput(type);
    input.classList.add("blueprint");
    blueprints.appendChild(input);
  });

  //init drag & drop on the form
  form.addEventListener("dragover", function (e) {
    e.preventDefault();

    //remove all flags
    const flaged = this.querySelectorAll(".input.insert-before");
    let i = 0;
    const len = flaged.length;
    for (; i < len; i++) flaged[i].classList.remove("insert-before");

    //highlight the remove area
    if (e.target === deleteArea) deleteArea.classList.add("highlight");
    else deleteArea.classList.remove("highlight");

    //search for other input
    let target = e.target;
    while (target !== this) {
      if (target.classList.contains("input")) break;
      target = target.parentNode;
    }
    if (target === this) return;

    //highlight the input under the cursor
    target.classList.add("insert-before");
  });
  form.addEventListener("drop", function (e) {
    e.preventDefault();

    const type = e.dataTransfer.getData("type");
    const newInput = form.data.inDrag || genInput(type);

    deleteArea.classList.remove("highlight");
    if (e.target === deleteArea) {
      if (newInput.parentNode) {
        constraints.remove(newInput);
        newInput.parentNode.removeChild(newInput);
      }
      return;
    }

    //get flagged
    let flagged = this.querySelector(".input.insert-before");
    if (!flagged) {
      this.appendChild(newInput);
      return;
    }

    flagged.classList.remove("insert-before");
    this.insertBefore(newInput, flagged);
  });

  function showPreview() {
    //remove old first
    const old = preview.querySelector(".form-viewer");
    if (old) preview.removeChild(old);

    //show
    const formViewer = new FormViewer();
    formViewer.formImageProvider = formImageProvider;
    const json = getJson();
    formViewer.loadJson(json);
    preview.appendChild(formViewer.node);
    CONTENT_TARGET.currentContent.data.formViewer = formViewer; //for debuging only
  }

  function getJson() {
    const json = [];
    let allInputs = form.querySelectorAll("table.input");
    allInputs = Array.from(allInputs);

    allInputs.map((input) => json.push(input.getJson()));
    return JSON.stringify(json);
  }

  /**
   * Generates an node some inputs and <i>getJson()</i> an <i>setValue()</i>.
   * Also drag and drop event listeners
   * @param {string} type
   * @returns {Element}
   */
  function genInput(type) {
    const node = document.createElement("table");
    //functions on node
    node.getJson = () => console.warn(type + ".getJson() not implemented yet");
    node.setJson = () => console.warn(type + ".setJson() not implemented yet");

    // -- generic stuff --

    node.draggable = true;
    node.classList.add("input");
    node.classList.add("input-" + type);
    node.classList.add("mdl-shadow--2dp");
    node.classList.add("tablerelative");

    node.insertAdjacentHTML(
      "beforeend",
      `
            <tr>
                <td>
                        <h4>${lng.get("form-input-" + type)}</h4>
                </td>
                <td>
                        <i class="material-icons absright">arrow_drop_up</i>
                </td>
                </tr>

            <tr>
                <td class="options"><table></table></td>
            </tr>
            <tr>
                <td class="inputs"></td>
            </tr>
        `
    );
    node.children[0].children[0].classList.add("cursorpointer");
    node.children[0].children[0].addEventListener("click", function () {
      for (let i = 1; i < this.parentNode.children.length; i++)
        this.parentNode.children[i].classList.toggle("removeitem");
      const arrow = this.querySelector("i");
      if (arrow.innerHTML === "arrow_drop_up")
        arrow.innerHTML = "arrow_drop_down";
      else arrow.innerHTML = "arrow_drop_up";
    });

    const nodeInput = node.querySelector(".inputs");
    const nodeOptions = node.querySelector(".options table");

    node.addEventListener("dragstart", function (e) {
      e.dataTransfer.setData("type", type);

      //if node is not inside the blueprint wrapper, tell the form wich node is currently draging
      if (!this.classList.contains("blueprint")) form.data.inDrag = this;
    });
    node.addEventListener("dragend", function (e) {
      form.data.inDrag = null;
    });

    // -- type specific stuff --
    //html, the getter and setter

    switch (type) {
      case "sign":
        genSign();
        break;
      case "address":
        genAddress();
        break;
      case "tel":
        genTel();
        break;
      case "default":
        genDefault({
          nodeOptions: nodeOptions,
          node: node,
          nodeInput: nodeInput,
          constraints: constraints,
          type: type,
          addGenericOption: addGenericOption,
          validName: validName,
        });
        break;
      case "text":
        genText();
        break;
      case "textArea":
        genTextArea();
        break;
      case "multichoice":
        genMultiChoice();
        break;
      case "raffle":
        genRaffle();
        break;
      case "image":
        genImage();
        break;
      case "hr":
        genHr();
        break;
      default:
        console.error("Type " + type + " not implemented");
    }

    const allInputs = node.querySelectorAll("input");
    allInputs.forEach((input) => {
      input.addEventListener("mouseenter", (e) => {
        node.draggable = false;
      });

      input.addEventListener("mouseleave", (e) => {
        node.draggable = true;
      });
    });

    return node;

    function genHr() {
      node.getJson = function () {
        var result = {
          type: type,
          meta: { name: "Trennlinie" },
          data: {},
        };
        result.data.height =
          nodeOptions.querySelector("input[name=height]").value;
        return result;
      };
      node.setJson = function (data) {
        nodeOptions.querySelector("input[name=height]").value =
          data.data.height;
      };
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                     <tr>
                        <td>${lng.get("form-input-hr-height")}</td>
                        <td><input type="number" name="height" size=3 min=1 max=10 value="1"></td>
                    </tr>
                `
      );
    }

    function genSign() {
      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: {},
        };

        //meta
        result.meta.label =
          nodeOptions.querySelector("input[name=label]").value;
        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.required = nodeOptions.querySelector(
          "input[name=required]"
        ).checked;

        return result;
      };

      node.setJson = function (data) {
        //meta
        nodeOptions.querySelector("input[name=label]").value = data.meta.label;
        nodeOptions.querySelector("input[name=name]").value = data.meta.name;
        nodeOptions.querySelector("input[name=required]").checked =
          data.meta.required;
      };

      addGenericOption("label");
      addGenericOption("name");
      addGenericOption("required");
    }

    function genTel() {
      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: {},
        };
        result.meta.label =
          nodeOptions.querySelector("input[name=label]").value;
        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.vorwahl = nodeOptions.querySelector(
          "input[name=vorwahl]"
        ).checked;
        result.meta.autooptin = nodeOptions.querySelector(
          "input[name=autooptin]"
        ).checked;
        result.meta.mobileValidation = nodeOptions.querySelector(
          "input[name=mobileValidation]"
        ).checked;
        result.meta.required = nodeOptions.querySelector(
          "input[name=required]"
        ).checked;
        result.meta.exportNumber = nodeOptions.querySelector(
          "input[name=exportNumber]"
        ).value;
        result.meta.exportNumberArea = nodeOptions.querySelector(
          "input[name=exportNumberArea]"
        ).value;
        result.meta.exportMobile = nodeOptions.querySelector(
          "input[name=exportMobile]"
        ).value;
        result.meta.exportMobileArea = nodeOptions.querySelector(
          "input[name=exportMobileArea]"
        ).value;

        return result;
      };

      node.setJson = function (data) {
        nodeOptions.querySelector("input[name=label]").value = data.meta.label;
        nodeOptions.querySelector("input[name=name]").value = data.meta.name;
        nodeOptions.querySelector("input[name=vorwahl]").checked =
          data.meta.vorwahl;
        nodeOptions.querySelector("input[name=autooptin]").checked =
          data.meta.autooptin;
        nodeOptions.querySelector("input[name=mobileValidation]").checked =
          data.meta.mobileValidation;
        nodeOptions.querySelector("input[name=required]").checked =
          data.meta.required;
        nodeOptions.querySelector("input[name=exportNumber]").value =
          data.meta.exportNumber || "";
        nodeOptions.querySelector("input[name=exportNumberArea]").value =
          data.meta.exportNumberArea || "";
        nodeOptions.querySelector("input[name=exportMobile]").value =
          data.meta.exportMobile || "";
        nodeOptions.querySelector("input[name=exportMobileArea]").value =
          data.meta.exportMobileArea || "";

        if (data.meta.vorwahl) {
          nodeOptions
            .querySelector("input[name=exportNumberArea]")
            .parentNode.parentNode.classList.remove("dont-display");
          nodeOptions
            .querySelector("input[name=exportMobileArea]")
            .parentNode.parentNode.classList.remove("dont-display");
        }
      };
      addGenericOption("label");
      addGenericOption("name");
      addGenericOption("required");
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-tel-vorwahl")}</td>
                        <td><input type="checkbox" name="vorwahl"></td>
                    </tr>
                `
      );
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-tel-autooptin")}</td>
                        <td><input type="checkbox" name="autooptin"></td>
                    </tr>
                `
      );
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-tel-validation")}</td>
                        <td><input type="checkbox" name="mobileValidation"></td>
                    </tr>
                `
      );
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-tel-export-number")}</td>
                        <td><input type="text" name="exportNumber"></td>
                    </tr>
                `
      );
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr class="dont-display">
                        <td>${lng.get("form-input-tel-export-number-area")}</td>
                        <td><input type="text" name="exportNumberArea"></td>
                    </tr>
                `
      );
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-tel-export-mobile")}</td>
                        <td><input type="text" name="exportMobile"></td>
                    </tr>
                `
      );
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr class="dont-display">
                        <td>${lng.get("form-input-tel-export-mobile-area")}</td>
                        <td><input type="text" name="exportMobileArea"></td>
                    </tr>
                `
      );
      const exportNumberArea = nodeOptions.querySelector(
        "input[name=exportNumberArea]"
      );
      const exportNumberAreaTr = exportNumberArea.parentNode.parentNode;
      const exportMobileArea = nodeOptions.querySelector(
        "input[name=exportMobileArea]"
      );
      const exportMobileAreaTr = exportMobileArea.parentNode.parentNode;
      const vorwahl = nodeOptions.querySelector("input[name=vorwahl]");
      vorwahl.addEventListener("click", (e) => {
        if (e.target.checked) {
          exportNumberAreaTr.classList.remove("dont-display");
          exportMobileAreaTr.classList.remove("dont-display");
        } else {
          exportNumberAreaTr.classList.add("dont-display");
          exportMobileAreaTr.classList.add("dont-display");
        }
      });
    }

    function genTextArea() {
      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: {},
        };

        //meta
        result.meta.label =
          nodeOptions.querySelector("input[name=label]").value;
        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.required = nodeOptions.querySelector(
          "input[name=required]"
        ).checked;
        result.meta.height =
          nodeOptions.querySelector("input[name=height]").value;
        result.meta.placeholder = nodeOptions.querySelector(
          "input[name=placeholder]"
        ).value;
        return result;
      };

      node.setJson = function (data) {
        //meta
        nodeOptions.querySelector("input[name=label]").value = data.meta.label;
        nodeOptions.querySelector("input[name=name]").value = data.meta.name;
        nodeOptions.querySelector("input[name=required]").checked =
          data.meta.required;
        nodeOptions.querySelector("input[name=height]").value =
          data.meta.height;
        nodeOptions.querySelector("input[name=placeholder]").value =
          data.meta.placeholder;
      };
      addGenericOption("label");
      addGenericOption("name");
      addGenericOption("required");
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-textArea-height")}</td>
                        <td><input type="number" name="height" size=3 min=1 max=10 value="1"></td>
                    </tr>
                    <tr>
                        <td>${lng.get("form-input-textArea-placeholder")}</td>
                        <td><input type="text" name="placeholder"></td>
                    </tr>
                `
      );
    }

    function genAddress() {
      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: {},
        };

        //meta
        result.meta.label =
          nodeOptions.querySelector("input[name=label]").value;
        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.required = nodeOptions.querySelector(
          "input[name=required]"
        ).checked;
        result.meta.checkPostalCode = nodeOptions.querySelector(
          "input[name=checkPostalCode]"
        ).checked;
        result.meta.epaper =
          nodeOptions.querySelector("input[name=epaper]").checked;
        result.meta.epaperEverywhere = nodeOptions.querySelector(
          "input[name=epaperEverywhere]"
        ).checked;
        result.meta.eitherOr = nodeOptions.querySelector(
          "input[name=eitherOr]"
        ).checked;

        result.meta.exportPostal = nodeOptions.querySelector(
          "input[name=exportPostal]"
        ).value;
        result.meta.exportCity = nodeOptions.querySelector(
          "input[name=exportCity]"
        ).value;
        result.meta.exportStreet = nodeOptions.querySelector(
          "input[name=exportStreet]"
        ).value;
        result.meta.exportStreetNumber = nodeOptions.querySelector(
          "input[name=exportStreetNumber]"
        ).value;
        result.meta.exportAddition = nodeOptions.querySelector(
          "input[name=exportAddition]"
        ).value;
        result.meta.exportPrint = nodeOptions.querySelector(
          "input[name=exportPrint]"
        ).value;
        result.meta.exportEpaper = nodeOptions.querySelector(
          "input[name=exportEpaper]"
        ).value;

        return result;
      };

      node.setJson = function (data) {
        //meta
        nodeOptions.querySelector("input[name=label]").value = data.meta.label;
        nodeOptions.querySelector("input[name=name]").value = data.meta.name;
        nodeOptions.querySelector("input[name=required]").checked =
          data.meta.required;
        nodeOptions.querySelector("input[name=checkPostalCode]").checked =
          data.meta.checkPostalCode;

        nodeOptions.querySelector("input[name=exportPostal]").value =
          data.meta.exportPostal || "";
        nodeOptions.querySelector("input[name=exportCity]").value =
          data.meta.exportCity || "";
        nodeOptions.querySelector("input[name=exportStreet]").value =
          data.meta.exportStreet || "";
        nodeOptions.querySelector("input[name=exportStreetNumber]").value =
          data.meta.exportStreetNumber || "";
        nodeOptions.querySelector("input[name=exportAddition]").value =
          data.meta.exportAddition || "";
        nodeOptions.querySelector("input[name=exportPrint]").value =
          data.meta.exportPrint || "";
        nodeOptions.querySelector("input[name=exportEpaper]").value =
          data.meta.exportEpaper || "";

        // --- aditional epaper logic
        const epaperInput = nodeOptions.querySelector("input[name=epaper]");
        epaperInput.checked = data.meta.epaper;
        const epaperEverywhereInput = nodeOptions.querySelector(
          "input[name=epaperEverywhere]"
        );
        epaperEverywhereInput.checked = data.meta.epaperEverywhere;
        const eitherOr = nodeOptions.querySelector("input[name=eitherOr]");
        eitherOr.checked = data.meta.eitherOr;

        if (epaperInput.checked) {
          epaperEverywhereInput.parentNode.parentNode.classList.remove(
            "dont-display"
          );
          eitherOr.parentNode.parentNode.classList.remove("dont-display");
          exportPrint.parentNode.parentNode.classList.remove("dont-display");
          exportEpaper.parentNode.parentNode.classList.remove("dont-display");
          //TODO: We have to think about this constraint. Normally an email input should only be required
          // when a user chooses epaper and not print. Currently an email is always required.g
          //  constraints.add(node, existEmailInput, existEmailInputClear);
        }
      };

      addGenericOption("label");
      addGenericOption("name");
      addGenericOption("required");

      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get(
                          "form-input-address-checkPostalCode"
                        )}</td>
                        <td><input type="checkbox" name="checkPostalCode"></td>
                    </tr>
                     <tr>
                        <td>${lng.get("form-input-address-epaper-print")}</td>
                        <td><input type="checkbox" name="epaper"></td>
                    </tr>
                     <tr class="dont-display">
                        <td>${lng.get(
                          "form-input-address-epaper-everywhere"
                        )}</td>
                        <td><input type="checkbox" name="epaperEverywhere"></td>
                    </tr>
                     <tr class="dont-display">
                        <td>${lng.get(
                          "form-input-address-epaper-either-or"
                        )}</td>
                        <td><input type="checkbox" checked name="eitherOr"></td>
                    </tr>
                     <tr>
                        <td>${lng.get("form-input-address-export-postal")}</td>
                        <td><input type="text" name="exportPostal"></td>
                    </tr>
                     <tr>
                        <td>${lng.get("form-input-address-export-city")}</td>
                        <td><input type="text" name="exportCity"></td>
                    </tr>
                     <tr>
                        <td>${lng.get("form-input-address-export-street")}</td>
                        <td><input type="text" name="exportStreet"></td>
                    </tr>
                     <tr>
                        <td>${lng.get(
                          "form-input-address-export-street-number"
                        )}</td>
                        <td><input type="text" name="exportStreetNumber"></td>
                    </tr>
                     <tr>
                        <td>${lng.get(
                          "form-input-address-export-addition"
                        )}</td>
                        <td><input type="text" name="exportAddition"></td>
                    </tr>
                     <tr  class="dont-display">
                        <td>${lng.get("form-input-address-export-print")}</td>
                        <td><input type="text" name="exportPrint"></td>
                    </tr>
                     <tr  class="dont-display">
                        <td>${lng.get("form-input-address-export-epaper")}</td>
                        <td><input type="text" name="exportEpaper"></td>
                    </tr>
                `
      );

      // --- additional epaper logic
      var epaperInput = nodeOptions.querySelector('input[name="epaper"]');
      var epaperEverywhereInput = nodeOptions.querySelector(
        'input[name="epaperEverywhere"]'
      );
      const epaperEverywhereInputTr =
        epaperEverywhereInput.parentNode.parentNode;
      const epaperEitherOr = nodeOptions.querySelector(
        'input[name="eitherOr"]'
      );
      const epaperEitherOrTr = epaperEitherOr.parentNode.parentNode;
      var exportEpaper = nodeOptions.querySelector("input[name=exportEpaper]");
      const exportEpaperTr = exportEpaper.parentNode.parentNode;
      var exportPrint = nodeOptions.querySelector("input[name=exportPrint]");
      const exportPrintTr = exportPrint.parentNode.parentNode;

      epaperInput.addEventListener("click", (e) => {
        if (e.target.checked) {
          // constraints.add(node, existEmailInput, existEmailInputClear);
          // constraints.callAll();

          epaperEverywhereInputTr.classList.remove("dont-display");
          epaperEitherOrTr.classList.remove("dont-display");
          exportEpaperTr.classList.remove("dont-display");
          exportPrintTr.classList.remove("dont-display");
        } else {
          // constraints.remove(node);
          epaperEverywhereInputTr.classList.add("dont-display");
          epaperEverywhereInput.checked = false;
          epaperEitherOrTr.classList.add("dont-display");
          epaperEitherOr.checked = true;
          exportEpaperTr.classList.add("dont-display");
          exportPrintTr.classList.add("dont-display");
        }
      });
    }

    function genRaffle() {
      const nAnswers = {
        _n: 0,
        set n(val) {
          val = parseInt(val);
          val = Math.max(0, val);
          val = Math.min(10, val);

          while (val > this._n) {
            pushAnswer();
            this._n++;
          }
          while (val < this._n) {
            popAnswer();
            this._n--;
          }
        },
        get n() {
          return this._n;
        },
      };

      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: {},
        };
        result.meta.label =
          nodeOptions.querySelector("input[name=label]").value;
        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.required = nodeOptions.querySelector(
          "input[name=required]"
        ).checked;
        result.meta.multiple = nodeOptions.querySelector(
          "input[name=multiple]"
        ).checked;

        Array.from(tbody.querySelectorAll("tr.raffle")).forEach(
          (answerTr, i) => {
            // Note: we have to use that strange text{i} notation instead of a simple array,
            // because of backwards compatibility with already existing datasets
            result.data[`text${i + 1}`] =
              answerTr.getElementsByClassName("ql-editor")[0].innerHTML;
            result.data[`text${i + 1}_disableAddressCheckbox`] =
              answerTr.getElementsByClassName(
                "disable-address-checkboxes"
              )[0].checked;
          }
        );
        return result;
      };

      node.setJson = function (data) {
        nodeOptions.querySelector("input[name=label]").value = data.meta.label;
        nodeOptions.querySelector("input[name=name]").value = data.meta.name;
        nodeOptions.querySelector("input[name=required]").checked =
          data.meta.required;
        nodeOptions.querySelector("input[name=multiple]").checked =
          data.meta.multiple;

        nAnswers.n = 0;
        for (let d in data.data) {
          if (
            d.indexOf("text") === 0 &&
            d.indexOf("_disableAddressCheckbox") === -1
          ) {
            // `text${i}`

            let hideAddressCheckbox;
            switch (data.data[d + "_disableAddressCheckbox"]) {
              case true:
                hideAddressCheckbox = true;
                break;
              case false:
                hideAddressCheckbox = false;
                break;
              case undefined: // compatibility mode
                hideAddressCheckbox = d === "text2";
            }

            pushAnswer(data.data[d], hideAddressCheckbox);
            nAnswers._n++;
          }
        }
        tbody.querySelector("input.nAnswers").value = nAnswers.n;
      };

      addGenericOption("label");
      addGenericOption("name");
      addGenericOption("required");

      const tbody = document.createElement("tbody");

      // create field to change number of answers
      const nChangeTr = document.createElement("tr");
      nChangeTr.insertAdjacentHTML(
        "afterbegin",
        `
                <tr>
                    <td>${lng.get("form-input-raffle-nAnswers")}</td>
                    <td><input type="number" class="nAnswers" min="1" max="10" step="1" value="2"></td>
                </tr>
            `
      );
      nChangeTr
        .getElementsByTagName("input")[0]
        .addEventListener("change", (e) => (nAnswers.n = e.target.value));
      tbody.appendChild(nChangeTr);

      // checkbox for allowing multiple choice or not
      const multipleChoiceTr = document.createElement("tr");
      multipleChoiceTr.insertAdjacentHTML(
        "afterbegin",
        `
                <tr>
                    <td>${lng.get("form-input-raffle-multiple")}</td>
                    <td><input type="checkbox" name="multiple"></td>
                </tr>
            `
      );
      tbody.appendChild(multipleChoiceTr);

      // adds the answers, should be after the other settings
      nAnswers.n = 2; // default

      // should be last cause of redraws
      nodeOptions.appendChild(tbody);

      function pushAnswer(content, disableAddressCheckbox) {
        const tr = document.createElement("tr");
        tr.classList.add("raffle");

        const tdName = document.createElement("td");
        tr.appendChild(tdName);
        // checkbox for disabling address checkbox
        tdName.insertAdjacentHTML(
          "beforeend",
          `
                    <label>
                        <input type="checkbox" class="disable-address-checkboxes" ${
                          disableAddressCheckbox ? "checked" : ""
                        }>
                        ${lng.get("form-input-raffle-disableAddressCheckbox")}
                    </label>
                `
        );

        const tdInput = document.createElement("td");
        tdInput.colSpan = "2";
        const textDiv = document.createElement("div");
        textDiv.classList.add("textdiv");
        tdInput.appendChild(textDiv);
        tr.appendChild(tdInput);

        tbody.appendChild(tr);

        new Quill(textDiv, {
          modules: {
            toolbar: [
              [{ size: ["small", false, "large", "huge"] }],
              ["bold", "italic", "underline", { color: [] }],
              ["clean"],
            ],
          },
          placeholder: `${lng.get("form-input-text-text")}`,
          theme: "snow",
        });

        if (content) {
          textDiv.querySelector(".ql-editor").innerHTML = content;
        }
      }

      function popAnswer() {
        const answers = tbody.getElementsByClassName("raffle");
        const lastAnswer = answers[answers.length - 1];
        lastAnswer.parentNode.removeChild(lastAnswer);
      }
    }

    function genMultiChoice() {
      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: [],
        };
        //meta
        result.meta.label =
          nodeOptions.querySelector("input[name=label]").value;
        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.required = nodeOptions.querySelector(
          "input[name=required]"
        ).checked;
        result.meta.multic =
          nodeOptions.querySelector("input[name=multic]").checked;
        //data
        const allInputTables = nodeInput.querySelectorAll("table");
        let i = 0;
        const len = allInputTables.length;
        for (; i < len; i++) {
          const data = allInputTables[i].data;
          const inputData = {};

          for (let key in data) inputData[key] = data[key];

          result.data.push(inputData);
        }

        return result;
      };
      node.setJson = function (data) {
        //meta
        nodeOptions.querySelector("input[name=label]").value = data.meta.label;
        nodeOptions.querySelector("input[name=name]").value = data.meta.name;
        nodeOptions.querySelector("input[name=required]").checked =
          data.meta.required;
        nodeOptions.querySelector("input[name=multic]").checked =
          data.meta.multic;
        const nInputs = data.data.length;
        nodeOptions.querySelector("input[name=nInputs]").value = nInputs;

        //data
        nodeInput.removeInput();
        for (let i = 0; i < nInputs; i++) {
          const dataset = data.data[i];
          const inputTable = nodeInput.addInput();

          for (let key in dataset) {
            const seterName = "set" + key[0].toUpperCase() + key.substr(1);
            let setFunction = inputTable[seterName];
            if (typeof setFunction !== "function") {
              console.error("Default input seter " + seterName + " not found.");
              continue;
            }
            setFunction(dataset[key]);
          }
        }
      };
      nodeInput.addInput = function () {
        const table = document.createElement("table");
        table.data = {};
        table.setLabel = function (val) {
          table.data.label = val;
          labelInput.value = val;
        };
        table.setCheck = function (val) {
          table.data.check = val;
          checkInput.checked = val;
        };
        let tr = document.createElement("tr");
        table.appendChild(tr);
        let td = document.createElement("td");
        tr.appendChild(td);
        td.textContent = lng.get("form-input-multichoice-answer");
        td = document.createElement("td");
        tr.appendChild(td);
        tr.setAttribute("attr", "label");
        var labelInput = document.createElement("input");
        labelInput.type = "text";
        labelInput.required = true;
        td.appendChild(labelInput);
        tr = document.createElement("tr");
        tr.setAttribute("attr", "check");
        table.appendChild(tr);
        td = document.createElement("td");
        tr.appendChild(td);
        td.textContent = lng.get("form-input-multichoice-entry");
        td = document.createElement("td");
        tr.appendChild(td);
        var checkInput = document.createElement("input");
        checkInput.type = "checkbox";
        td.appendChild(checkInput);

        labelInput.addEventListener("change", (e) =>
          table.setLabel(labelInput.value)
        );
        checkInput.addEventListener("change", (e) =>
          table.setCheck(checkInput.checked)
        );
        nodeInput.appendChild(table);
        return table;
      };
      nodeInput.removeInput = function () {
        const all = nodeInput.children;
        if (all.length === 0) return;
        nodeInput.removeChild(all[all.length - 1]);
      };
      addGenericOption("label");
      addGenericOption("name");
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr> 
                        <td>${lng.get("form-attribute-required")}</td>
                        <td><input type="checkbox" name="required"></td>
                    </tr>
                    <tr>
                        <td>${lng.get("form-input-multichoice-multic")}</td>
                        <td><input type="checkbox" name="multic" checked></td>
                    </tr>
                    <tr>
                        <td>${lng.get("form-input-default-nInputs")}</td>
                        <td><input type="number" name="nInputs" size=3 min=1 max=15 value="1"></td>
                    </tr>
                `
      );

      //if user change the nInputs value, add or remove inputs
      const nInput = nodeOptions.querySelector("input[name=nInputs]");
      nInput.addEventListener("change", function (e) {
        let n = this.value;
        const nCurrentInputs = nodeInput.children.length;

        //take care of min and max
        n = Math.max(this.min, n);
        n = Math.min(this.max, n);
        this.value = n;

        if (nCurrentInputs < n) {
          //add some inputs
          let diff = n - nCurrentInputs;
          while (diff-- > 0) nodeInput.addInput();
        } else {
          //remove some inputs
          for (let i = nCurrentInputs; i > n; i--) nodeInput.removeInput();
        }
      });
      nInput.dispatchEvent(new Event("change"));
    }

    function genText() {
      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: {},
        };

        //meta
        result.meta.checkbox = nodeOptions.querySelector(
          "input[name=checkbox]"
        ).checked;
        result.meta.label =
          nodeOptions.querySelector("input[name=label]").value;
        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.required = nodeOptions.querySelector(
          "input[name=required]"
        ).checked;
        result.meta.textlength = nodeOptions.querySelector(
          "input[name=textlength]"
        ).value;
        result.meta.smalltext = nodeOptions.querySelector(
          "input[name=smalltext]"
        ).checked;

        //data
        // result.data.text = nodeInput.querySelector('textarea[name=text]').value;
        const test = nodeOptions.querySelector("div[id=text] div");

        result.data.text = test.innerHTML;
        return result;
      };

      node.setJson = function (json) {
        //meta
        nodeOptions.querySelector("input[name=checkbox]").checked =
          json.meta.checkbox;
        nodeOptions.querySelector("input[name=label]").value = json.meta.label;
        nodeOptions.querySelector("input[name=name]").value = json.meta.name;
        nodeOptions.querySelector("input[name=required]").checked =
          json.meta.required;
        nodeOptions.querySelector("input[name=textlength]").value =
          json.meta.textlength;
        nodeOptions.querySelector("input[name=smalltext]").checked =
          json.meta.smalltext;
        //data
        // nodeInput.querySelector('textarea[name=text]').value = json.data.text;
        const test = nodeOptions.querySelector("div[id=text] div");
        test.innerHTML = json.data.text;
      };

      //nodeInput.insertAdjacentHTML('beforeend', `
      //    <textarea name="text" cols=30 rows=9 placeholder="${lng.get('form-input-text-text')}"></textarea>
      //`);

      const tr = document.createElement("tr");
      const td = document.createElement("td");
      td.colSpan = "2";
      const textdiv = document.createElement("div");

      textdiv.id = "text";
      tr.appendChild(td);
      td.appendChild(textdiv);
      nodeOptions.appendChild(tr);

      const editor = new Quill(textdiv, {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline", { color: [] }],
            ["clean"],
          ],
        },
        placeholder: `${lng.get("form-input-text-text")}`,
        theme: "snow",
      });

      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-text-checkbox")}</td>
                        <td><input type="checkbox" name="checkbox"><span>${lng.get(
                          "form-input-text-checkboxNote"
                        )}<span></td>
                    </tr>`
      );
      addGenericOption("label");
      addGenericOption("name");
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-text-smalltext")}</td>
                        <td><input type="checkbox" name="smalltext"><span>${lng.get(
                          "form-input-text-smalltextNote"
                        )}<span></td>
                    </tr>`
      );
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-text-textlength")}</td>
                        <td><input type="number" name="textlength" size=3 min=1 max=10 value="2"></td>
                    </tr>
                `
      );
      addGenericOption("required");

      const checkboxInput = nodeOptions.querySelector("input[name=checkbox]");
      const labelInput = nodeOptions.querySelector("input[name=label]");
      const nameInput = nodeOptions.querySelector("input[name=name]");
      const smalltextInput = nodeOptions.querySelector("input[name=smalltext]");
      const textlengthInput = nodeOptions.querySelector(
        "input[name=textlength]"
      );
      smalltextInput.addEventListener("change", function () {
        textlengthInput.required = this.checked;
      });
      labelInput.required = false;
      nameInput.required = true;

      /*checkboxInput.addEventListener('change', function (e) {
                labelInput.required = this.checked;
                nameInput.required = this.checked;
            });*/
    }

    function genImage() {
      nodeOptions.setAttribute("attr", "optionsImage");

      node.getJson = function () {
        const result = {
          type: type,
          meta: {},
          data: {},
        };

        result.meta.name = nodeOptions.querySelector("input[name=name]").value;
        result.meta.partner = partnerCheckbox.checked;

        if (!result.meta.partner)
          result.data.image = imageInput.data.id || imageInput.data.oldId;

        return result;
      };

      node.setJson = function (json) {
        nodeOptions.querySelector("input[name=name]").value = json.meta.name;
        partnerCheckbox.checked = json.meta.partner;
        imageInput.disabled = json.meta.partner;
        imageInput.required = false; //first cause of possibility to no changes

        if (json.meta.partner) return;

        //save old image id
        imageInput.data.oldId = json.data.image;

        //load image
        imageThumb.src =
          schema.formImage.endPoint + "/" + imageInput.data.oldId;
        formImageProvider.add(json.meta.name, imageThumb.src);
      };

      nodeInput.insertAdjacentHTML(
        "beforeend",
        `
                <input type="file" name="image" required>
                <img class="thumb">
            `
      );

      addGenericOption("name");
      nodeOptions.insertAdjacentHTML(
        "beforeend",
        `
                    <tr>
                        <td>${lng.get("form-input-image-partner")}</td>
                        <td><input type="checkbox" name="partner"></td>
                    </tr>`
      );

      var imageInput = nodeInput.querySelector("input[name=image]");
      var imageThumb = nodeInput.querySelector("img.thumb");
      var partnerCheckbox = nodeOptions.querySelector("input[name=partner]");
      const nameInput = nodeOptions.querySelector("input[name=name]");

      nameInput.addEventListener("change", function () {
        formImageProvider.add(nameInput.value, imageThumb.src); //set new image for preview
      });

      partnerCheckbox.addEventListener("change", function (e) {
        imageThumb.style.opacity = this.checked ? 0.5 : 1;
        imageInput.disabled = this.checked;
        imageInput.required = !this.checked;
      });

      imageInput.data = {};
      imageInput.addEventListener("change", function (e) {
        imageInput.required = true;

        if (this.files.length === 0) {
          imageThumb.file = null;
          return;
        }

        const file = this.files[0];
        const objectURL = URL.createObjectURL(file);
        imageThumb.src = objectURL;
        formImageProvider.add(nameInput.value, objectURL); //set new image for preview
      });

      /**
       * Store temporary the formId before <i>save()</i> is resolved.
       * Catch changed formId in <i>afterSave()</i>
       * @type string
       */
      let formIdCache;

      node.save = function () {
        //try to get formID
        /**
         * @type RestView
         */
        const restView = CONTENT_TARGET.currentContent.data.restView;

        const formId = restView._subject.data.id;
        formIdCache = formId; //store for afterSave()

        //if no new image was added, do nothing and continue i afterSave()
        if (imageInput.files.length === 0)
          return new Promise((resolve) => resolve());

        //upload new image
        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("image", imageInput.files[0]);

          //not use Network.open here cause of other content-type
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.open("POST", schema.formImage.endPoint);
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            switch (xhr.status) {
              case 201:
                const data = JSON.parse(xhr.responseText);

                //put new id to input[name=image].data.id for getJson()
                imageInput.data.id = data.id;
                resolve();
                break;
              default:
                snackbar.show({ message: lng.get(xhr.status) });
                reject();
            }
          };
          xhr.onerror = () => reject(xhr);
          xhr.send(formData);
        });
      };

      /**
       * After the Form was updated, call this with the potencial new formId
       * to assign the formImage to the form.
       * @param {string} newFormId
       * @returns {Promise}
       */
      node.afterSave = function (newFormId) {
        const oldFormId = formIdCache;
        const newImageId = imageInput.data.id;
        const oldImageId = imageInput.data.oldId;

        let state;
        state = newImageId ? "NewImage" : "OldImage";
        state += newFormId !== oldFormId ? "NewForm" : "OldForm";

        switch (state) {
          case "NewImageNewForm":
            //add new image to new form
            return new Promise((resolve, reject) => {
              const xhr = Network.openXHR(
                "POST",
                schema.formImage.endPoint +
                  "/" +
                  newImageId +
                  "/form/" +
                  newFormId
              );
              xhr.onreadystatechange = function () {
                if (xhr.readyState !== XMLHttpRequest.DONE) return;

                switch (xhr.status) {
                  case 201:
                  case 200:
                    return resolve();
                  default:
                    return reject();
                }
              };
              xhr.send();
            });

          case "NewImageOldForm":
            //remove old image from old form
            //add new image to old form

            return Promise.all([
              new Promise((resolve, reject) => {
                const xhr = Network.openXHR(
                  "DELETE",
                  schema.formImage.endPoint +
                    "/" +
                    oldImageId +
                    "/form/" +
                    oldFormId
                );
                xhr.onreadystatechange = function () {
                  if (xhr.readyState !== XMLHttpRequest.DONE) return;

                  //trust api do it right (cause Promise.all this should not be allowed to reject)
                  return resolve();
                };
                xhr.send();
              }),
              new Promise((resolve, reject) => {
                const xhr = Network.openXHR(
                  "POST",
                  schema.formImage.endPoint +
                    "/" +
                    newImageId +
                    "/form/" +
                    oldFormId
                );
                xhr.onreadystatechange = function () {
                  if (xhr.readyState !== XMLHttpRequest.DONE) return;

                  switch (xhr.status) {
                    case 201:
                    case 200:
                      return resolve();
                    default:
                      return reject();
                  }
                };
                xhr.send();
              }),
            ]);

          case "OldImageNewForm":
            //add old image to new form

            return new Promise((resolve, reject) => {
              const xhr = Network.openXHR(
                "POST",
                schema.formImage.endPoint +
                  "/" +
                  oldImageId +
                  "/form/" +
                  newFormId
              );
              xhr.onreadystatechange = function () {
                if (xhr.readyState !== XMLHttpRequest.DONE) return;

                switch (xhr.status) {
                  case 201:
                  case 200:
                    return resolve();
                  default:
                    return reject();
                }
              };
              xhr.send();
            });

          case "OldImageOldForm":
            //nothing to do
            return new Promise((resolve) => resolve());
        }
      };
    }

    /**
     * Remove all not allowed chars from string
     * @param {string} name
     * @returns {string}
     */
    function validName(name) {
      //sadly this have to be inside this function. Cause of scope
      const allowedChars =
        "QWERTZUIOPASDFGHJKLYXCVBNMqwertzuiopasdfghjklyxcvbnmÄÖÜäöüß1234567890-_ ".split(
          ""
        );

      const validName = [];
      for (let i = 0, len = name.length; i < len; i++) {
        const char = name[i];

        //exclude not allowed chars
        if (allowedChars.indexOf(char) === -1) continue;

        validName.push(char);
      }

      //check if name is unique in the whole form
      const allNameInputs = form.querySelectorAll("input[name=name]");
      const currentNames = [];

      //check all. this also prevents old messages
      for (let i = 0, len = allNameInputs.length; i < len; i++) {
        const nameInput = allNameInputs[i];
        const inputName = nameInput.value;
        if (inputName === "") continue;

        if (currentNames.indexOf(inputName) !== -1) {
          nameInput.setCustomValidity("not unique");
          snackbar.show({ message: lng.get("validation_unique") });
        } else if (FormExportCsvBuilder.reserved.indexOf(name) !== -1) {
          nameInput.setCustomValidity("reserved");
          snackbar.show({ message: lng.get("validation_reserved") });
        } else {
          nameInput.setCustomValidity("");
        }

        currentNames.push(inputName);
      }

      return validName.join("");
    }

    function addGenericOption(option) {
      switch (option) {
        case "name":
          nodeOptions.insertAdjacentHTML(
            "beforeend",
            `
                            <tr>
                                <td>${lng.get("form-attribute-name")}</td>
                                <td><input type="text" name="name" required></td>
                            </tr>
                        `
          );
          const nameInput = nodeOptions.querySelector("input[name=name]");
          nameInput.addEventListener("change", function (e) {
            this.value = validName(this.value);
          });
          break;
        case "label":
          nodeOptions.insertAdjacentHTML(
            "beforeend",
            `
                            <tr>
                                <td>${lng.get("form-attribute-titel")}</td>
                                <td><input type="text" name="label"></td>
                            </tr>
                        `
          );
          break;
        case "required":
          nodeOptions.insertAdjacentHTML(
            "beforeend",
            `
                            <tr>
                                <td>${lng.get("form-attribute-required")}</td>
                                <td><input type="checkbox" name="required"></td>
                            </tr>
                        `
          );
          break;
        default:
          console.error("Generic option " + option + " not implemented");
      }
    }

    /* ----- Constraints -----
      /**
       * Proofs if an email input exists, if not, make ctx invalid. The invalidation is indicated by the css class invalid.
       * In addtion a snackbar message is shown to explain the user what is wrong
       * @param ctx context part that will be added an invalid css class if no email is available
        */
    function existEmailInput(ctx, called) {
      let emailInput = form.querySelector("table[type=email");
      let contactInput = form.querySelector("tr[attr=contact] input:checked");
      if (!emailInput || !contactInput) {
        ctx.classList.add("invalid");

        // tooltip
        ctx.classList.add("tooltip");
        ctx.dataset.tooltip = lng.get("validation_short_no-email");

        if (!called) {
          snackbar.show({ message: lng.get("validation_no-email") });
        }
        return true;
      } else {
        ctx.classList.remove("invalid");

        // tooltip
        ctx.classList.remove("tooltip");
        ctx.dataset.tooltip = "";
        return false;
      }
    }

    function existEmailInputClear(ctx) {
      ctx.classList.remove("invalid");
    }
  }
}
